/**
 * The fabric books, by name. Admin only.
 */
import { NamedItemsPage } from '../named-items/NamedItemsPage';
import { fabricBookService } from './api';

export function FabricBooksPage() {
  return (
    <NamedItemsPage
      service={fabricBookService}
      listLabel="Fabric books"
      showEmptyRows
    />
  );
}
